import { CourseFlatDTO } from "../domain/models/dto/CourseDTO";
import { ICourseFlat } from "../domain/models/Course";
import { BaseModelImpl } from "./BaseModelImpl";

export class CourseFlatModel
    extends BaseModelImpl<CourseFlatDTO>
    implements ICourseFlat
{
    id?: string;
    files?: any[];
    title: string;
    shortContent: string;
    description: string;
    author: string;
    duration: string;
    topic: string;
    imageUrl?: string;
    languageCode: string;
    creatorId?: string;
    createdAt?: Date;
    updatedAt?: Date;
    updatorId?: string;

    constructor(data?: CourseFlatDTO) {
        super();
        this.assignData(data);
    }
}
